var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-name" }, [
          _c("h2", { attrs: { id: "benefitHeader" } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.pageTitle) +
                "\n                "
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary pull-right",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.buttonBack.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Back")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content CustomPadTop0" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              { attrs: { id: "changeProfile" } },
              [
                _vm.$route.path.indexOf("/adduserlocation") >= 0
                  ? [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.firstName,
                                  expression: "firstName"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "firstName",
                                placeholder: "Enter First Name"
                              },
                              domProps: { value: _vm.firstName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.firstName = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.firstNameError))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.lastName,
                                  expression: "lastName"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "lastName",
                                placeholder: "Enter Last Name"
                              },
                              domProps: { value: _vm.lastName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.lastName = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.lastNameError))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "email",
                                placeholder: "Enter Email"
                              },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.emailError))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  name: "location",
                                  placeholder: "Type location here",
                                  label: "location_name",
                                  id: "selectedLocationWhileAdd",
                                  options: _vm.locationOptions
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onchangeLocation()
                                  }
                                },
                                model: {
                                  value: _vm.selectedLocationWhileAdd,
                                  callback: function($$v) {
                                    _vm.selectedLocationWhileAdd = $$v
                                  },
                                  expression: "selectedLocationWhileAdd"
                                }
                              }),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.locationWhileAddError))
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "selectedWillCallLocation" } },
                                [_vm._v("Select Secondary Location")]
                              ),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  name: "willcalllocation",
                                  placeholder: "Type location here",
                                  label: "location_name",
                                  id: "selectedWillCallLocationWhileAdd",
                                  options: _vm.locationOptions
                                },
                                model: {
                                  value: _vm.selectedWillCallLocationWhileAdd,
                                  callback: function($$v) {
                                    _vm.selectedWillCallLocationWhileAdd = $$v
                                  },
                                  expression: "selectedWillCallLocationWhileAdd"
                                }
                              }),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.locationWhileAddError))
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _vm._m(4),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  name: "role",
                                  placeholder: "Type Role here",
                                  label: "role_name",
                                  id: "selectedRoleWhileAdd",
                                  options: _vm.roleOptions
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onchangeRole()
                                  }
                                },
                                model: {
                                  value: _vm.selectedRoleWhileAdd,
                                  callback: function($$v) {
                                    _vm.selectedRoleWhileAdd = $$v
                                  },
                                  expression: "selectedRoleWhileAdd"
                                }
                              }),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.roleWhileAddError))
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 CustomAML" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.allowMultipleLoginWhileAdd,
                                      expression: "allowMultipleLoginWhileAdd"
                                    }
                                  ],
                                  attrs: { type: "checkbox", value: "" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.allowMultipleLoginWhileAdd
                                    )
                                      ? _vm._i(
                                          _vm.allowMultipleLoginWhileAdd,
                                          ""
                                        ) > -1
                                      : _vm.allowMultipleLoginWhileAdd
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.allowMultipleLoginWhileAdd,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.allowMultipleLoginWhileAdd = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.allowMultipleLoginWhileAdd = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.allowMultipleLoginWhileAdd = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v("Allow Multiple Login")
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "row clearfix" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-12 input-group mt-3" },
                          [
                            _c("div", { staticClass: "button-demo" }, [
                              _c("input", {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  id: "addUser",
                                  type: "button",
                                  value: "Add"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.addUser()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  id: "backButtonUser",
                                  type: "button",
                                  value: "Cancel"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.buttonBack.apply(null, arguments)
                                  }
                                }
                              })
                            ])
                          ]
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.path.indexOf("/updateuserlocation") >= 0
                  ? [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.firstNameWhileUpdate,
                                  expression: "firstNameWhileUpdate"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "firstNameWhileUpdate",
                                placeholder: "Enter First Name"
                              },
                              domProps: { value: _vm.firstNameWhileUpdate },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.firstNameWhileUpdate = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.firstNameWhileUpdateError))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _vm._m(6),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.lastNameWhileUpdate,
                                  expression: "lastNameWhileUpdate"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "lastNameWhileUpdate",
                                placeholder: "Enter Last Name"
                              },
                              domProps: { value: _vm.lastNameWhileUpdate },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.lastNameWhileUpdate = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.lastNameWhileUpdateError))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _vm._m(7),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.emailWhileUpdate,
                                  expression: "emailWhileUpdate"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "emailWhileUpdate",
                                placeholder: "Enter Email"
                              },
                              domProps: { value: _vm.emailWhileUpdate },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.emailWhileUpdate = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.emailWhileUpdateError))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _vm._m(8),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  name: "location",
                                  placeholder: "Type location here",
                                  label: "location_name",
                                  id: "selectedLocation",
                                  options: _vm.locationOptions
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onchangeLocation()
                                  }
                                },
                                model: {
                                  value: _vm.selectedLocation,
                                  callback: function($$v) {
                                    _vm.selectedLocation = $$v
                                  },
                                  expression: "selectedLocation"
                                }
                              }),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.locationError))
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "selectedWillCallLocation" } },
                                [_vm._v("Select Secondary Location")]
                              ),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  name: "willcalllocation",
                                  placeholder: "Type location here",
                                  label: "location_name",
                                  id: "selectedWillCallLocation",
                                  options: _vm.locationOptions
                                },
                                model: {
                                  value: _vm.selectedWillCallLocation,
                                  callback: function($$v) {
                                    _vm.selectedWillCallLocation = $$v
                                  },
                                  expression: "selectedWillCallLocation"
                                }
                              }),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.locationWhileAddError))
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _vm._m(9),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  name: "role",
                                  placeholder: "Type role here",
                                  label: "role_name",
                                  id: "selectedRole",
                                  options: _vm.roleOptions
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onchangeRole()
                                  }
                                },
                                model: {
                                  value: _vm.selectedRole,
                                  callback: function($$v) {
                                    _vm.selectedRole = $$v
                                  },
                                  expression: "selectedRole"
                                }
                              }),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.roleError))
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.allowMultipleLoginWhileUpdate,
                                      expression:
                                        "allowMultipleLoginWhileUpdate"
                                    }
                                  ],
                                  staticClass: "updateCheckbox",
                                  attrs: { type: "checkbox", value: "" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.allowMultipleLoginWhileUpdate
                                    )
                                      ? _vm._i(
                                          _vm.allowMultipleLoginWhileUpdate,
                                          ""
                                        ) > -1
                                      : _vm.allowMultipleLoginWhileUpdate
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a =
                                          _vm.allowMultipleLoginWhileUpdate,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.allowMultipleLoginWhileUpdate = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.allowMultipleLoginWhileUpdate = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.allowMultipleLoginWhileUpdate = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v("Allow Multiple Login")
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-12 input-group mt-3" },
                          [
                            _c("div", { staticClass: "button-demo" }, [
                              _c("input", {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  id: "addLocation",
                                  type: "button",
                                  value: "Update"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.updateUserDetails()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  id: "backButtonLocation",
                                  type: "button",
                                  value: "Cancel"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.buttonBack.apply(null, arguments)
                                  }
                                }
                              })
                            ])
                          ]
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("app-footer")
              ],
              2
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "firstName" } }, [
      _vm._v("First Name"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "lastName" } }, [
      _vm._v("Last Name"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "email" } }, [
      _vm._v("Email"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "selectedLocation" } }, [
      _vm._v("Select Primary Location"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "selecteRole" } }, [
      _vm._v("Select Role"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "firstNameWhileUpdate" } }, [
      _vm._v("First Name"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "lastNameWhileUpdate" } }, [
      _vm._v("Last Name"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "emailWhileUpdate" } }, [
      _vm._v("Email"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "selectedLocation" } }, [
      _vm._v("Select Primary Location"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "selectedRole" } }, [
      _vm._v("Select Role"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68676d3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68676d3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddUserLocation.vue
// module id = null
// module chunks = 